import '../css'

$(document).on('click', 'form .image .remove', function(e) {
  e.preventDefault()
  $(this).parent().remove()
})
